module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.83b7cdda9637ed08bd4b.js");
};